import React, { ChangeEvent, useState } from "react";
import FileUpload from "./FileUpload";

interface Props {
  handleFileUpload: (file: File, schoolName: string) => void;
  backToDefault: () => void;
  uploadStatus: number;
}

const ExcelAccountCreation: React.FC<Props> = ({
  handleFileUpload,
  backToDefault,
  uploadStatus,
}) => {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);

  return (
    <>
      <button
        onClick={backToDefault}
        className="text-white bg-[#131CC9] hover:bg-[#0f1699] border border-[#131CC9] rounded-2xl m-2 p-2 md:p-3 transition-colors duration-200 text-sm md:text-base"
      >
        Retour
      </button>
      <div className="w-full h-full bg-white py-8 md:py-12 px-4 md:px-0">
        <FileUpload
          handleFileUpload={handleFileUpload}
          uploadStatus={uploadStatus}
        />
      </div>
    </>
  );
};

export default ExcelAccountCreation;
